import { Link2, Send, Layers, Instagram, Youtube, Twitter, Linkedin, Facebook, Github, Twitch, Music2, Globe } from "lucide-react";

// Simplified block model. Historical blocks (product, contact, image, etc.)
// still render on the public page but can no longer be created; anything
// legacy the creator opens gets converted to a link on save.
export const BLOCK_TYPES = {
  link: {
    label: "Link card",
    icon: Link2,
    defaults: {
      destination_url: "",
      fetched_image_url: "",
      uploaded_image_url: "",
      image_crop_data: null,
      title: "",
      description: "",
      badge: "",
    },
  },
  lead_form: {
    label: "Lead form",
    icon: Send,
    defaults: {
      title: "Get in touch",
      description: "Send me a message — I'll get back to you.",
      badge: "",
      uploaded_image_url: "",
      // form_configuration is a small map, one entry per field.
      form_configuration: {
        name: { enabled: true, required: true },
        email: { enabled: true, required: true },
        phone: { enabled: false, required: false },
        message: { enabled: true, required: false },
      },
      success_message: "Thanks — I'll be in touch soon.",
    },
  },
  section: {
    label: "Group heading",
    icon: Layers,
    defaults: {
      title: "My favourites",
      subtitle: "",
      default_open: true,
    },
  },
};

// Displayed image for a Link/Lead-form block: uploaded > fetched > empty.
// A single helper so preview + published page can never diverge.
export function pickImage(block) {
  return block?.uploaded_image_url || block?.fetched_image_url || "";
}

export const SOCIAL_PLATFORMS = {
  instagram: Instagram, youtube: Youtube, twitter: Twitter, x: Twitter,
  linkedin: Linkedin, facebook: Facebook, github: Github, twitch: Twitch,
  tiktok: Music2, spotify: Music2, website: Globe,
};

export const FONT_OPTIONS = [
  "Inter", "Poppins", "Montserrat", "Playfair Display", "Space Grotesk", "DM Sans", "Georgia",
];

// Parse a video URL into an embeddable src (kept for legacy `video` blocks).
export function toEmbedUrl(url) {
  if (!url) return null;
  try {
    let m = url.match(/(?:youtube\.com\/(?:watch\?v=|embed\/)|youtu\.be\/)([\w-]{11})/);
    if (m) return `https://www.youtube.com/embed/${m[1]}`;
    m = url.match(/open\.spotify\.com\/(track|playlist|album|episode|show)\/([\w]+)/);
    if (m) return `https://open.spotify.com/embed/${m[1]}/${m[2]}`;
    m = url.match(/vimeo\.com\/(\d+)/);
    if (m) return `https://player.vimeo.com/video/${m[1]}`;
  } catch {
    return null;
  }
  return null;
}

